import React, { useEffect, useState } from "react";
import CartGrid from "./CartGrid";
import CartDetails from "./CartDetails";
import { CartPageProvider } from "../../../Context/CartTableContext";
import BreadCrumb from "../../BreadCrumb/BreadCrumb";
import { useCartInventoryContext } from "../../../Context/Cache/CartInventoryContext";
import { useAuthenticationContext } from "../../../Context/Authentication";
import { Link, useLocation } from "react-router-dom"; // Amit
import ThankYouPage from "../ThankyouPage/ThankYouPage";
import { LoadingScreen, ProceedingLoadingScreen } from "../../LoadingScreen";
import ExcelJS from 'exceljs';
import { FaFileExport } from "react-icons/fa6";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { strToU8, zipSync } from 'fflate';

const MainCartPage = () => {
  const { deleteAllProducts, cartProduct, selectedRows, setSelectedRows, currentPath,
    setCurrentPath,exportExcelName, displayThankYouPage, setDisplayThankYouPage, isLoading, visibleColumnsRepl, visibleColumns } = useCartInventoryContext();
  const { screenSize } = useAuthenticationContext();
  const hasCartProducts = cartProduct && cartProduct.length > 0;
  // Amit
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  useEffect(() => {
    if (pathnames != currentPath) {
      setSelectedRows([]);
      setCurrentPath(pathnames);
    }
  }, [])


  const toDataURL = (url, width = 70, height = 70) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        const base64Url = canvas.toDataURL("image/jpeg");
        resolve({ base64Url });
      };
      img.onerror = function () {
        reject(new Error("Failed to load image at " + url));
      };
      img.src = url;
    });
  };

  // const handleExcelExport = async () => {

  //   const data = cartProduct.map((item) => {
  //     if(item.nyc_atuid != null){
  //       var tempArray = {};
  //       tempArray.Image = {
  //         text: 'Image Link',
  //         hyperlink: `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.nyc_sku || 'placeholder'}.png`
  //       }
  //        tempArray.SKU = item.nyc_sku;
  //        tempArray.Brand = item['_nyc_brand_value@OData.Community.Display.V1.FormattedValue'];
  //        tempArray.UPC = item.nyc_upc;
  //        tempArray["Product Name"] = item.nyc_productname;
  //        tempArray.Color = item.nyc_name;
  //        tempArray.Size = item.nyc_size;
  //        tempArray["Available Quantity"] = item.nyc_availablequantity;
  //        tempArray["Requested Quantity"] = item.requestedQuantity==undefined?"-":item.requestedQuantity;
  //       return tempArray;
  //     }
  //     else{
  //       var tempArray = {};
  //       tempArray.Image = {
  //         text: 'Image Link',
  //         hyperlink: `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.productnumber || 'placeholder'}.jpg`
  //       }
  //        tempArray.SKU = item.productnumber;
  //        tempArray.Brand = item.nyc_brand;
  //        tempArray.UPC = item.nyc_upc;
  //        tempArray["Product Name"] =  item.name
  //        tempArray.Color = item.nyc_color;
  //        tempArray.Size = item.size;
  //        tempArray["Available Quantity"] = item.strava_availablequantity;
  //        tempArray["Requested Quantity"] = item.requestedQuantity==undefined?"-":item.requestedQuantity;
  //        tempArray.Price = `$${(item.price).toFixed(2)}`;
  //        tempArray.MSRP =`$${(item.nyc_msrp).toFixed(2)}`;
  //        tempArray["Offer Price"] = item.counterOffer==undefined?"-":item.counterOffer;
  //       return tempArray;
  //     }

  // });
  //  console.log("excel data",data);
  //   // console.log("Data:",inventoryFilteredProducts);
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Sheet1');
  //   if(data[0]==undefined){
  //     toast.warning("please select some rows");
  //     return;
  //   }
  //   const headers = Object.keys(data[0]);
  //   worksheet.addRow(headers);

  //   data.forEach((item) => {
  //     const row = worksheet.addRow(Object.values(item));
  //     if(headers.indexOf('Image')!=-1){
  //       const imageCell = row.getCell(headers.indexOf('Image') + 1);
  //       if (imageCell.value && imageCell.value.text === 'Image Link') {
  //         imageCell.font = { color: { argb: '550000FF' } , underline: 'single'};
  //       }
  //     }
  //   });
  //  const headerRow = worksheet.getRow(1);
  //   headerRow.height = 40;
  //   headerRow.eachCell((cell) => {
  //     cell.fill = {
  //       type: 'pattern',
  //       pattern: 'solid',
  //       fgColor: { argb: 'FFDDDDDD' },
  //     };
  //     cell.border={
  //       top: { style: 'thin', color: { argb: '000000' } },
  //       left: { style: 'thin', color: { argb: '000000' } },
  //       bottom: { style: 'thin', color: { argb: '000000' } },
  //       right: { style: 'thin', color: { argb: '000000' } },
  //     }
  //     cell.alignment = { vertical: 'middle', horizontal: 'center' };
  //     cell.font = {
  //       bold: true,
  //       size: 12,
  //     };
  //   });

  //   worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
  //     if (rowNumber > 1) {
  //       row.height = 70;
  //       if (rowNumber % 2 !== 0) {
  //         row.eachCell({ includeEmpty: true }, (cell) => {
  //           cell.fill = {
  //             type: 'pattern',
  //             pattern: 'solid',
  //             fgColor: { argb: 'FFFFF1F6' },
  //           };
  //         });
  //       }
  //     }
  //     row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
  //       cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true  };
  //       cell.border = {
  //         top: { style: 'thin', color: { argb: '000000' } },
  //         left: { style: 'thin', color: { argb: '000000' } },
  //         bottom: { style: 'thin', color: { argb: '000000' } },
  //         right: { style: 'thin', color: { argb: '000000' } },
  //       };
  //     });
  //   });

  //   worksheet.columns.forEach(column => {
  //     let maxLength = 0;
  //     column.eachCell({ includeEmpty: true }, (cell) => {
  //       if (cell.value) {
  //         const cellValue = cell.value.toString();
  //         maxLength = Math.max(maxLength, cellValue.length);
  //       }
  //     });
  //     column.width = Math.min(Math.max(maxLength + 2, 10), 30);
  //   });

  //   // const packagingColumnIndex = headers.indexOf('Packaging') + 1;
  //   // worksheet.getColumn(packagingColumnIndex).width = 15;



  //   const today = new Date();
  //   const pad = (num) => num.toString().padStart(2, '0');
  //   const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;

  //   workbook.xlsx.writeBuffer().then((data) => {
  //     const blob = new Blob([data], {
  //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     const anchor = document.createElement('a');
  //     anchor.href = url;
  //     anchor.download = `NewYorkCosmetics-${formattedDate}.xlsx`;
  //     document.body.appendChild(anchor);
  //     anchor.click();
  //     document.body.removeChild(anchor);
  //     window.URL.revokeObjectURL(url);
  //   });
  // };

  // const handleExcelExport = async (email) => {

  //   const data = cartProduct.map((item) => {
  //     if (item.nyc_atuid != null) {
  //       var tempArray = {};
  //       tempArray.Image = `https://nycdatastorage.blob.core.windows.net/compressproduct-uatcontain/${item.nyc_sku || 'placeholder'}.png`;
  //       tempArray.SKU = item.nyc_sku;
  //       tempArray.Brand = item['_nyc_brand_value@OData.Community.Display.V1.FormattedValue'];
  //       tempArray["Product Name"] = item.nyc_productname;
  //       tempArray.Color = item.nyc_name;
  //       tempArray.Size = item.size + " " + item.nyc_sizeuom;// Feedback Change for gap and UOM
  //       tempArray.UPC = item.nyc_upc;
  //       tempArray["Available Quantity"] = item.nyc_availablequantity;
  //       tempArray["Requested Quantity"] = item.requestedQuantity == undefined ? "-" : item.requestedQuantity;
  //       tempArray.Price = `$${(item.nyc_price).toFixed(2)}`;
  //       return tempArray;
  //     }
  //     else {
  //       var tempArray = {};
  //       tempArray.Image = `https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${item.productnumber || 'placeholder'}.jpg`;
  //       tempArray.SKU = item.productnumber;
  //       tempArray.Brand = item.nyc_brand;
  //       tempArray["Product Name"] = item.name
  //       tempArray.Color = item.nyc_color;
  //       tempArray.Size = item.size + " " + item.nyc_sizeuom; // Feedback Change for UOM and gap
  //       tempArray.UPC = item.nyc_upc;
  //       tempArray["Available Quantity"] = item.strava_availablequantity;
  //       tempArray["Requested Quantity"] = item.requestedQuantity == undefined ? "-" : item.requestedQuantity;
  //       tempArray.Price = `$${(item.price).toFixed(2)}`;
  //       tempArray.MSRP = `$${(item.nyc_msrp).toFixed(2)}`;
  //       // tempArray["Offer Price"] = item.counterOffer == undefined ? "-" : item.counterOffer;
  //       tempArray["Offer Price"] = item.counterOffer == undefined ? "-" : `$${Number(item.counterOffer).toFixed(2)}`; // Feedback changes
  //       return tempArray;
  //     }

  //   });
  //   console.log("excel data", data);
  //   // console.log("Data:",inventoryFilteredProducts);
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Sheet1');
  //   worksheet.views = [{ state: 'frozen', ySplit: 1 }];
  //   if (data[0] == undefined) {
  //     toast.warning("please select some rows");
  //     return;
  //   }
  //   const headers = Object.keys(data[0]);
  //   worksheet.addRow(headers);

  //   data.forEach((item) => {
  //     const row = worksheet.addRow(Object.values(item));
  //     if (headers.indexOf('Image') != -1) {
  //       const imageCell = row.getCell(headers.indexOf('Image') + 1);
  //       if (imageCell.value && imageCell.value.text === 'Image Link') {
  //         imageCell.font = { color: { argb: '550000FF' }, underline: 'single' };
  //       }
  //     }
  //   });
  //   const headerRow = worksheet.getRow(1);
  //   headerRow.height = 33;
  //   headerRow.eachCell((cell) => {
  //     cell.fill = {
  //       type: 'pattern',
  //       pattern: 'solid',
  //       fgColor: { argb: 'FF973131' },
  //     };
  //     cell.border = {
  //       top: { style: 'thin', color: { argb: '000000' } },
  //       left: { style: 'thin', color: { argb: '000000' } },
  //       bottom: { style: 'thin', color: { argb: '000000' } },
  //       right: { style: 'thin', color: { argb: '000000' } },
  //     }
  //     cell.alignment = { vertical: 'middle', horizontal: 'center' };
  //     cell.font = {
  //       bold: true,
  //       size: 12,
  //       color: { argb: 'FFFFFFFF' },
  //     };
  //   });

  //   worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
  //     if (rowNumber > 1) {
  //       row.height = 80;
  //       if (rowNumber % 2 !== 0) {
  //         row.eachCell({ includeEmpty: true }, (cell) => {
  //           cell.fill = {
  //             type: 'pattern',
  //             pattern: 'solid',
  //             // fgColor: { argb: rowNumber % 2 === 0 ? 'FFFFFFFF' : 'FFFFE7E7' },
  //             fgColor: 'FFFFFFFF'
  //           };
  //         });
  //       }
  //     }
  //     row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
  //       cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  //       cell.border = {
  //         top: { style: 'thin', color: { argb: '000000' } },
  //         left: { style: 'thin', color: { argb: '000000' } },
  //         bottom: { style: 'thin', color: { argb: '000000' } },
  //         right: { style: 'thin', color: { argb: '000000' } },
  //       };
  //     });
  //   });

  //   // worksheet.columns.forEach(column => {
  //   //   let maxLength = 0;
  //   //   column.eachCell({ includeEmpty: true }, (cell) => {
  //   //     if (cell.value) {
  //   //       const cellValue = cell.value.toString();
  //   //       maxLength = Math.max(maxLength, cellValue.length);
  //   //     }
  //   //   });
  //   //   column.width = Math.min(Math.max(maxLength + 2, 10), 30);
  //   // });

  //   // const packagingColumnIndex = headers.indexOf('Packaging') + 1;
  //   // worksheet.getColumn(packagingColumnIndex).width = 15;


  //   // set Image column width
  //   // const imageColumnIndex = headers.indexOf('Image') + 1;
  //   // const imagecolumn = worksheet.getColumn(imageColumnIndex);
  //   // if (imagecolumn) {
  //   //   imagecolumn.width = 12;
  //   // }

  //   worksheet.columns.forEach((column, index) => {
  //   const header = headers[index];
 
  //   if (header === "Image") column.width = 18;
  //   else if (header === "SKU") column.width = 18;
  //   else if (header === "Brand") column.width = 18;
  //   else if (header === "Available Quantity") column.width = 16;
  //   else if (header === "Requested Quantity") column.width = 16;
  //   else if (header === "Product Name") column.width = 45;
  //   else if (header === "UPC") column.width = 18;
  //   else column. Width = 14;
  // });
  //   const today = new Date();
  //   const pad = (num) => num.toString().padStart(2, '0');
  //   const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;

  //   const excelName = `NewYorkCosmetics-${formattedDate}.xlsx`;

  //   // Write the workbook to a buffer and convert to Base64
  //   const base64Excel = await workbook.xlsx.writeBuffer().then((buffer) => {
  //     return btoa(
  //       new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
  //     );
  //   });

  //   console.log("Excel Name:", excelName);
  //   // console.log( base64Excel); // Store or send this Base64 as needed
  //   console.log(email);
  //   const payload = {
  //     fileName: excelName,
  //     emailAddress: email,
  //     fileContent: base64Excel
  //   };
  //   //console.log("endpoint: "+process.env.REACT_APP_UAT_AZURE_EXPORT_EXCEL_FUNCTION_ENDPOINT);
  //   toast.success("Preparing your download, please check your email shortly.");

  //   axios.post(
  //     process.env.REACT_APP_AZURE_EXPORT_EXCEL_FUNCTION_ENDPOINT,
  //     payload,
  //     {
  //       headers: {
  //         "Content-Type": "application/json"
  //       }
  //     }
  //   )
  //     .then((response) => {
  //       console.log(response.data);
  //       toast.success("Excel sent to " + email);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });

  //   // workbook.xlsx.writeBuffer().then((data) => {
  //   //   const blob = new Blob([data], {
  //   //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //   //   });
  //   //   const url = window.URL.createObjectURL(blob);
  //   //   const anchor = document.createElement('a');
  //   //   anchor.href = url;
  //   //   anchor.download = `NewYorkCosmetics-${formattedDate}.xlsx`;
  //   //   document.body.appendChild(anchor);
  //   //   anchor.click();
  //   //   document.body.removeChild(anchor);
  //   //   window.URL.revokeObjectURL(url);
  //   // });
  // };

 const handleExcelExport = async (email) => {

  if (!cartProduct || cartProduct.length === 0) {
    toast.warning("Cart is empty");
    return;
  }

  const loadingToastId = toast.loading("Compressing data and starting export...");

  try {

    // Send cart products as selectedRows so backend does not change
    const payload = {
      selectedRows: cartProduct,
      visibleColumns,
      email,
      exportExcelName
    };

    const dataUint8 = strToU8(JSON.stringify(payload));
    const compressed = zipSync({ "data.json": dataUint8 }, { level: 6 });

    const formData = new FormData();
    formData.append("file", new Blob([compressed]), "data.zip");

    const PROD_URL = process.env.REACT_APP_SERVER_URL;

    await axios.post(PROD_URL + "/api/data/export-products", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    toast.dismiss(loadingToastId);
    toast.success("Export started! You will receive an email shortly.");

  } catch (error) {

    toast.dismiss(loadingToastId);
    console.error("Export Error:", error);
    toast.error("Failed to send data to server.");

  }
};

  const handleExcelExportWithoutImage = async () => {

    const data = cartProduct.map((item) => {
      if (item.nyc_atuid != null) {
         var tempArray = {};
 
        tempArray.SKU = item.nyc_sku;
        tempArray.Brand = item['_nyc_brand_value@OData.Community.Display.V1.FormattedValue'];
        tempArray["Product Name"] = item.nyc_productname;
        tempArray.Color = item.nyc_name;
        tempArray.Size = item.size + " " + item.nyc_sizeuom; // Feedback Change for gap and UOM
        tempArray.UPC = item.nyc_upc;
        tempArray["Available Quantity"] = item.nyc_availablequantity;
        tempArray["Requested Quantity"] = item.requestedQuantity == undefined ? "-" : item.requestedQuantity;
        return tempArray;
      }
      else {
        var tempArray = {};
        tempArray.SKU = item.productnumber;
        tempArray.Brand = item.nyc_brand;
        tempArray["Product Name"] = item.name
        tempArray.Color = item.nyc_color;
        tempArray.Size = item.size + " " + item.nyc_sizeuom; // Feedback Change for UOM and gap
        tempArray.UPC = item.nyc_upc;
        tempArray["Available Quantity"] = item.strava_availablequantity;
        tempArray["Requested Quantity"] = item.requestedQuantity == undefined ? "-" : item.requestedQuantity;
        tempArray.Price = `$${(item.price).toFixed(2)}`;
        tempArray.MSRP = `$${(item.nyc_msrp).toFixed(2)}`;
        //tempArray["Offer Price"] = item.counterOffer == undefined ? "-" : item.counterOffer;
        tempArray["Offer Price"] = item.counterOffer == undefined ? "-" : `$${Number(item.counterOffer).toFixed(2)}`; // Feedback changes
        return tempArray;
      }

    });
    console.log("excel data", data);
    // console.log("Data:",inventoryFilteredProducts);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    worksheet.views = [{ state: 'frozen', ySplit: 1 }];
    if (data[0] == undefined) {
      toast.warning("please select some rows");
      return;
    }
    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);

    data.forEach((item) => {
      const row = worksheet.addRow(Object.values(item));

    });
    const headerRow = worksheet.getRow(1);
    headerRow.height = 40;
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF973131' },
      };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.font = {
        bold: true,
        size: 12,
        color: { argb: 'FFFFFFFF' },
      };
    });

    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      if (rowNumber > 1) {
        row.height = 70;
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            // fgColor: { argb: rowNumber % 2 === 0 ? 'FFFFFFFF' : 'FFFFE7E7' },
            fgColor: 'FFFFFFFF'
          };
        });
      }
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        };
      });
    });

    // worksheet.columns.forEach(column => {
    //   let maxLength = 0;
    //   column.eachCell({ includeEmpty: true }, (cell) => {
    //     if (cell.value) {
    //       const cellValue = cell.value.toString();
    //       maxLength = Math.max(maxLength, cellValue.length);
    //     }
    //   });
    //   column.width = Math.min(Math.max(maxLength + 2, 10), 30);
    // });

    // const packagingColumnIndex = headers.indexOf('Packaging') + 1;
    // const column = worksheet.getColumn(packagingColumnIndex);
    // if (column) {
    //   column.width = 15;
    // }

    worksheet.columns.forEach((column, index) => {
    const header = headers[index];
 
    if (header === "Image") column.width = 18;
    else if (header === "SKU") column.width = 18;
    else if (header === "Brand") column.width = 18;
    else if (header === "Available Quantity") column.width = 16;
    else if (header === "Requested Quantity") column.width = 16;
    else if (header === "Product Name") column.width = 45;
    else if (header === "UPC") column.width = 18;
    else column. Width = 14;
  });
  
    const today = new Date();
    const pad = (num) => num.toString().padStart(2, '0');
    const formattedDate = `${pad(today.getMonth() + 1)}.${pad(today.getDate())}.${today.getFullYear()}`;

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `NewYorkCosmetics-${formattedDate}.xlsx`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    });
  };
  /*
    This is to handle Export Excel functionality
    -send selected record with given email to Azure function which
     process excel and send it to provied email
  */
  const [showExportExcelPopup, setShowExportExcelPopup] = useState(false);
  const [exportExcelEmail, setExportExcelEmail] = useState("");
  const [exportExcelError, setExportExcelError] = useState("");
  const [includeImage, setIncludeImage] = useState("Yes");

  // Function to handle "OK" button click
  const handleExportExcelOkClick = () => {
    if (!exportExcelEmail) {
      setExportExcelError("Email is required");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(exportExcelEmail)) {
      setExportExcelError("Invalid email format");
    } else {
      setExportExcelError("");
      handleExcelOpenClosePopup(false)
      console.log("email: " + exportExcelEmail);
      includeImage == "Yes" ? handleExcelExport(exportExcelEmail) : handleExcelExportWithoutImage();
    }
  };

  // Function to close the popup
  const handleExcelOpenClosePopup = (value) => {
    if (value) {
      let email = getEmail();
      console.log("existing user email: " + email);
      if (email != null) {
        setExportExcelEmail(email);
      }
      setShowExportExcelPopup(true);
      setExportExcelError("");
    } else {
      setShowExportExcelPopup(false);
      setExportExcelError("");
    }

  };

  // get Existing user email
  function getEmail() {
    // Step 1: Check if EmailResponse is present in localStorage
    const emailResponse = localStorage.getItem("EmailResponse");

    if (emailResponse) {
      try {
        // Step 2: Parse the JSON string to an object
        const emailResponseObj = JSON.parse(emailResponse);

        // Step 3: Check if email exists in the parsed object
        if (emailResponseObj && emailResponseObj.email) {
          return emailResponseObj.email;
        }
      } catch (error) {
        console.error("Error parsing EmailResponse:", error);
      }
    }

    // Step 4: If no email found in EmailResponse, check NewUserEmail
    const newUserEmail = localStorage.getItem("NewUserEmail");

    if (newUserEmail) {
      return newUserEmail;
    }

    // Step 5: If no email found, return null
    return null;
  };


  return (
    <CartPageProvider>
      {displayThankYouPage && <ThankYouPage />}
      {/* {isLoading && <LoadingScreen />} */}
      {isLoading && <ProceedingLoadingScreen />}
      <div className="py-2 bg-gray-100 border" style={{ maxWidth: `${screenSize.width}px` }}>
        {hasCartProducts ? (
          <div className="row nycfix-cart-container" style={{ maxWidth: `${screenSize.width}px` }}>
            {/* Amit Export Excel */}
            <ToastContainer />
            {showExportExcelPopup && (
              <div
                className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-10 "
              >
                <div
                  className="bg-white p-8 rounded-lg shadow-lg w-400"
                  onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popup
                >


                  {/* Image Input */}
                  <div className="mb-4">
                    <label className="block text-gray-700 font-medium mb-1">
                      Include Image:
                    </label>
                    <div className="flex items-center space-x-4">
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="includeImage"
                          value="Yes"
                          checked={includeImage === "Yes"}
                          onChange={(e) => setIncludeImage(e.target.value)}
                          className="mr-2"
                        />
                        Yes
                      </label>
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="includeImage"
                          value="No"
                          checked={includeImage === "No"}
                          onChange={(e) => setIncludeImage(e.target.value)}
                          className="mr-2"
                        />
                        No
                      </label>
                    </div>
                  </div>
                  {/* Email Input */}
                  {includeImage == "Yes" &&
                    <>
                      <label className="block text-gray-700 font-medium mb-1">Enter Your Email:</label>
                      <input
                        type="email"
                        value={exportExcelEmail}
                        onChange={(e) => setExportExcelEmail(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded mb-2"
                        placeholder="example@example.com"
                        required
                      />
                    </>
                  }

                  {/* Error Message */}
                  {exportExcelError && <p className="text-red-500 mb-4">{exportExcelError}</p>}

                  {/* OK Button */}
                  <button
                    onClick={handleExportExcelOkClick}
                    className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600 mr-2"
                  >
                    OK
                  </button>

                  {/* Close Button */}
                  <button
                    onClick={() => setShowExportExcelPopup(false)}
                    className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
            <div className="flex gap-2.5">
              <div className="col-lg-12">
                <BreadCrumb />
              </div>
            </div>
            <div className="col-lg-12 flex my-3 mx-3">
              <div className="col-lg-9 flex justify-between pr-8 nycfix-delete" style={{ paddingRight: "50px" }}>
                <div className="font-bold">
                  <span>Cart Details</span>
                </div>
                <div className="font-semibold text-red-600 hover:cursor-pointer flex gap-2">
                  <button
                    className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md"
                    onClick={() => handleExcelOpenClosePopup(true)}
                  >
                    <FaFileExport />
                  </button>
                  <span onClick={deleteAllProducts}>Delete all</span>
                </div>
              </div>
              <div className="col-lg-3"></div>
            </div>
            <div className="min-h-screen flex flex-col gap-4 nycfix-grid" style={{ padding: "0px 37px 0px 53px" }}>
              <div className="flex flex-row-reverse sm:flex-col justify-between gap-4 nycfix-grid">
                <CartGrid />
                <CartDetails />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-center items-center bg-gray-100" style={{ maxWidth: `${screenSize.width}px`, height: `${screenSize.height - 100}px` }}>
            <div className="bg-white shadow-md rounded-lg p-6 w-full max-w-lg">
              <div className="flex flex-col items-center">
                <svg
                  className="w-16 h-16 text-gray-400 mb-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 3h2l.4 2M7 13h10l1.3-7H6.3L7 13zM16 16a2 2 0 1 1-4 0m4 0H7m6 0a2 2 0 1 0-4 0"
                  ></path>
                </svg>
                <p className="text-lg font-semibold text-gray-700 mb-2">
                  Your Cart is Empty
                </p>
                <p className="text-sm text-gray-500">
                  Please add items to the cart to proceed.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </CartPageProvider>
  );
};

export default MainCartPage;